import { PRIVACY_NOTE } from "./constants";

export const PrivacyNote = ({ testid }) => (
  <span className="block text-[11px] font-semibold" style={{ color: "#7A2E20" }} data-testid={testid}>{PRIVACY_NOTE}</span>
);
